export const ORIENTATION = 'Orientation';
export const SIZE = 'Size';
